import React from 'react';

function Contatti() {
  return (
    <section className="w-full h-full bg-white">
      <section className="relative bg-center bg-no-repeat bg-cover bg-[url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80)]">
        <div className="absolute inset-0 bg-black/75"></div>

        <div className="container relative max-w-screen-xl px-4 py-24 mx-auto sm:px-6 lg:px-8 lg:h-full lg:items-center lg:flex">
          <div className="mx-auto text-center text-white">
            <h1 className="text-5xl font-extrabold">Contact us</h1>
            <p className="max-w-xl mt-4 sm:leading-relaxed sm:text-xl">
              Need to get in touch with us? Fill the form below, we will reply
              to you as soon as possible!
            </p>
          </div>
        </div>
      </section>
      <div className="container mx-auto">
        <div className="bg-white rounded-lg">
          <div className="grid grid-cols-1 gap-8 p-10 md:grid-cols-2 auto-rows-fr ">
            <div className="relative order-last p-10 bg-white md:order-first">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11329.88050263621!2d10.2621749!3d44.7712201!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa943e94a615370b1!2seDriveLAB%20s.r.l.!5e0!3m2!1sit!2sit!4v1674339160858!5m2!1sit!2sit"
                allowfullscreen=""
                className="absolute top-0 left-0 w-full h-full"
                title="Google Maps"
              ></iframe>
            </div>
            <div className="">
              <h3 className="mb-4 text-3xl text-center">Contact form</h3>
              <form action="" class="space-y-4">
                <div>
                  <label class="sr-only" for="name">
                    First & Second Name
                  </label>
                  <input
                    class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
                    placeholder="First & Second Name"
                    type="text"
                    id="name"
                  />
                </div>
                <div>
                  <label class="sr-only" for="name">
                    Company
                  </label>
                  <input
                    class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
                    placeholder="Company"
                    type="text"
                    id="name"
                  />
                </div>

                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label class="sr-only" for="email">
                      Email
                    </label>
                    <input
                      class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
                      placeholder="Email"
                      type="email"
                      id="email"
                    />
                  </div>

                  <div>
                    <label class="sr-only" for="phone">
                      Phone Number
                    </label>
                    <input
                      class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
                      placeholder="Phone Number"
                      type="tel"
                      id="phone"
                    />
                  </div>
                </div>
                <div>
                  <label class="sr-only" for="message">
                    Message
                  </label>
                  <textarea
                    class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm resize-none"
                    placeholder="Message"
                    rows="8"
                    id="message"
                  ></textarea>
                </div>

                <div class="mt-4">
                  <button
                    type="submit"
                    class="inline-flex w-full items-center justify-center rounded-lg border-2 border-blue-500 hover:bg-blue-500 px-5 py-3 hover:text-white text-blue-500 sm:w-auto transition-all"
                  >
                    <span class="font-medium"> Send Message </span>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-3 h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contatti;
